import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { toCroppedImage } from '~/shared/utils/image'

export default class UniversityMiniCard extends BaseModel {
  static override constructorName = 'UniversityMiniCard'

  slug: string = ''
  name: string = ''
  'short_name': string = ''
  logo: string = ''
  image: string = ''
  'budget_avg_score': string = ''
  'budget_places_number': number = 0

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.image = toCroppedImage(data.image)
      this.logo = toCroppedImage(data.logo)
    }
  }
}

registerModel(UniversityMiniCard)
